export const CommonElementId = {
    MessageInputBox: "alme-message-input-box",
    AlmeLaunchButton: "launchIvaBtn",
};
